// FT-3581: an EAN with Atrias physical status Disconnected (E23) or Under construction (E30)
// is a Move-in. Keyed on the raw Atrias code first, human-readable string as fallback.
// Demolished (E31) and Connected (E22) are intentionally NOT move-ins.
export const isMoveInStatus = (statusType?: string, statusCode?: string): boolean => {
  const code = (statusCode ?? "").trim().toUpperCase();
  const status = (statusType ?? "").trim().toLowerCase();
  return code === "E23" || code === "E30" || status === "disconnected" || status === "under construction";
};
